if (!customElements.get('product-info')) {
  customElements.define('product-info', class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.quantity__input');
      this.currentVariant = this.querySelector('.product-variant-id');
      this.variantSelects = this.querySelector('variant-radios')
      this.submitButton = this.querySelector('[type="submit"]');
    }

    cartUpdateUnsubscriber = undefined;
    variantChangeUnsubscriber = undefined;

    connectedCallback() {
      if (!this.input) return;
      this.quantityForm = this.querySelector('.product-form__quantity');
      if (!this.quantityForm) return;
      this.setQuantityBoundries();  
      if (!this.dataset.originalSection) {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
      }
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        if (event.data.sectionId !== sectionId) return;
        this.updateQuantityRules(event.data.sectionId, event.data.html);
        this.setQuantityBoundries();
      });
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }

    setQuantityBoundries() {
      const data = {
        cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
        min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
        max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
        step: this.input.step ? parseInt(this.input.step) : 1
      }

      let min = data.min;
      const max = data.max === null ? data.max : data.max - data.cartQuantity;
      if (max !== null) min = Math.min(min, max);
      if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

      this.input.min = min;
      this.input.max = max;
      this.input.value = min;
      publish(PUB_SUB_EVENTS.quantityUpdate, undefined);  
    }

    fetchQuantityRules() {
      if (!this.currentVariant || !this.currentVariant.value) return;
      this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
      fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`).then((response) => {
        return response.text()
      })
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        this.updateQuantityRules(this.dataset.section, html);
        this.setQuantityBoundries();
      })
      .catch(e => {
        console.error(e);
      })
      .finally(() => {
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
      });
    }

    updateQuantityRules(sectionId, html) {
      const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
      const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
      for (let selector of selectors) { 
        const current = this.quantityForm.querySelector(selector);
        const updated = quantityFormUpdated.querySelector(selector);
        if (!current || !updated) continue;
        if (selector === '.quantity__input') {
          const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
          for (let attribute of attributes) {
            const valueUpdated = updated.getAttribute(attribute);
            if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
          }
        } else {
          current.innerHTML = updated.innerHTML;
        }
      }
    }
  }
)};



/* Boulgouiz perfume spray: individual scent descriptions */
(() => {
  const isPerfumeSpray = window.location.pathname.includes('/products/perfume-spray');
  const isPerfumeOil = /\/products\/perfume\/?$/.test(window.location.pathname);
  const isDropperOil = /\/products\/diffusers\/?$/.test(window.location.pathname);
  const isPerfumeOilSamples = /\/products\/samples\/?$/.test(window.location.pathname);
  if (!isPerfumeSpray && !isPerfumeOil && !isDropperOil && !isPerfumeOilSamples) return;

  const scentDescriptions = {
    'Oud': 'Deep, smoky and intensely luxurious. A commanding woody fragrance with rich Arabian warmth that leaves an unforgettable impression.',
    'Deset Orient': 'A captivating journey through warm, earthy woods. Patchouli, sandalwood, amber and musk create a sensual oriental fragrance full of mystery and depth.',
    'Bakhoor': 'Warm precious woods meet velvety rose in an irresistible blend. Rich, elegant and beautifully distinctive—a scent people will remember.',
    'Night Musk': 'A seductive floral musk with the enchanting softness of Jasmine Damas. Elegant, mysterious and perfect for evenings.',
    'White Musk': 'Clean, velvety and effortlessly sophisticated. A soft powdery musk that stays beautifully close to the skin.',
    'Musk Oriental': 'Rich, warm and deeply sensual. An alluring oriental musk created for those who love bold, captivating fragrances.',
    'Vanilla Classic': 'Smooth, creamy vanilla with an irresistible comforting sweetness. Timeless, elegant and deliciously addictive.',
    'Vanilla Exotic': 'Vanilla with a luxurious oriental twist. Rich, warm and indulgent, with an exotic character that makes it truly unforgettable.',
    'Jasmine Damas': 'An enchanting bouquet of radiant jasmine. Soft, feminine and beautifully elegant, with a floral trail that captivates the senses.',
    'Jasmine Oriental': 'Luminous jasmine wrapped in warm oriental richness. Sensual, sophisticated and wonderfully long-lasting.',
    'Yalang yalang': 'Fresh citrus brightness meets exotic tropical flowers. Vibrant, uplifting and irresistibly sensual.',
    'Patchouli': 'Deep, earthy and beautifully woody. A bold, grounding fragrance with a warm, sophisticated character.',
    'Amber': 'Golden, warm and luxuriously sensual. A rich, enveloping fragrance that feels elegant, comforting and irresistible.',
    'Mix Fruits': 'A delicious burst of bright, juicy fruits. Playful, uplifting and full of mouth-watering sweetness.',
    'Mimosa': 'Soft, powdery and delicately floral. A graceful, sun-kissed fragrance with an elegant touch of sweetness.',
    'Gardenia': 'Creamy white petals with a rich, captivating floral intensity. Luxurious, feminine and beautifully sophisticated.',
    'Green Apple': 'Crisp, juicy and bursting with freshness. A vibrant fruity fragrance that feels clean, bright and energising.',
    'Rose': 'The timeless elegance of velvety rose petals. Romantic, luxurious and beautifully feminine.',
    'Sandal Wood': 'Smooth, creamy and warmly woody. A refined, calming fragrance with an irresistibly luxurious depth.',
    'Fig': 'Luscious ripe fig balanced by a sophisticated woody effect. Smooth, distinctive and unexpectedly addictive.',
    'Peach': 'Juicy, velvety peach with a soft, irresistible sweetness. Bright, charming and beautifully seductive.',
    'Desert Orient': 'A captivating journey through warm, earthy woods. Patchouli, sandalwood, amber and musk create a sensual oriental fragrance full of mystery and depth.',
    'Bakhoor - wood & rose': 'Warm precious woods meet velvety rose in an irresistible blend. Rich, elegant and beautifully distinctive—a scent people will remember.',
    'Ylang Ylang': 'Fresh citrus brightness meets exotic tropical flowers. Vibrant, uplifting and irresistibly sensual.',
    'Grape Fruit': 'Sparkling, zesty and full of energy. A vibrant citrus fragrance with an elegant bittersweet edge.',
    'Grape Feruit': 'Sparkling, zesty and full of energy. A vibrant citrus fragrance with an elegant bittersweet edge.',
    'Bamboo': 'Clean, green and beautifully airy. A serene modern fragrance that feels fresh, calm and effortlessly refined.',
    'Ocean': 'Cool, aquatic and wonderfully refreshing. A crisp fragrance inspired by sea air and the freedom of the open ocean.',
    'Caramel': 'Golden, warm and deliciously indulgent. A rich gourmand scent with smooth, irresistible sweetness.',
    'Cramel': 'Golden, warm and deliciously indulgent. A rich gourmand scent with smooth, irresistible sweetness.',
    'Chocolate': 'Deep, velvety and luxuriously tempting. A rich chocolate fragrance with an irresistible gourmand warmth.',
    'Orange': 'Bright, juicy and sun-filled. A sparkling citrus fragrance that instantly feels fresh, vibrant and uplifting.',
    'Violet': 'Soft, powdery and beautifully floral. An elegant violet fragrance with a delicate, velvety charm.',
    'Caffe Espresso': 'Bold, dark and deliciously aromatic. The rich scent of freshly roasted espresso with a warm, sophisticated finish.',
    'Citron': 'Bright, sparkling and beautifully refreshing. A vibrant citrus fragrance with a clean, uplifting finish.',
    'Lavender': 'Soft, aromatic and wonderfully calming. An elegant lavender fragrance that brings a sense of serenity and timeless freshness.',
    'Marine': 'Fresh, airy and invigorating. A clean marine fragrance inspired by cool sea breezes and effortless coastal luxury.'
  };

  const scentNames = Object.keys(scentDescriptions);
  const resolveScentName = (value) => scentNames.find((name) => name.toLowerCase() === value.trim().toLowerCase());

  const updateScentDescription = (value) => {
    const scent = resolveScentName(value);
    const description = scentDescriptions[scent];
    const container = document.querySelector('.product__description');
    if (!description || !container) return;

    const displayNames = {
      'Deset Orient': 'Desert Orient',
      'Yalang yalang': 'Ylang Ylang',
      'Bakhoor - wood & rose': 'Bakhoor',
      'Grape Fruit': 'Grapefruit',
      'Grape Feruit': 'Grapefruit',
      'Cramel': 'Caramel',
      'Caffe Espresso': 'Caffè Espresso'
    };
    const displayName = displayNames[scent] || scent;
    const scentHtml = `<h3 class="h4" style="margin: 0 0 1rem;">Product Description</h3><p><strong>${displayName}</strong> — ${description}</p>`;

    if (isPerfumeOil || isDropperOil || isPerfumeOilSamples) {
      let scentContainer = container.querySelector('.boulgouiz-selected-scent');
      if (!scentContainer) {
        const firstParagraph = container.querySelector(':scope > p:first-child');
        if (firstParagraph && firstParagraph.textContent.trim().toLowerCase() === 'description') {
          firstParagraph.remove();
        }
        scentContainer = document.createElement('div');
        scentContainer.className = 'boulgouiz-selected-scent';
        container.prepend(scentContainer);
      }
      scentContainer.innerHTML = scentHtml;
    } else {
      container.innerHTML = scentHtml;
    }
  };

  const selectedScent = () => {
    const selectedOptions = document.querySelectorAll(
      'variant-selects select[name^="options"], variant-radios input[name^="options"]:checked'
    );
    const matchingOption = Array.from(selectedOptions).find((option) => resolveScentName(option.value));
    return matchingOption ? matchingOption.value : '';
  };

  document.addEventListener('change', (event) => {
    if (!event.target.matches('select[name^="options"], input[name^="options"]')) return;
    window.setTimeout(() => updateScentDescription(selectedScent()), 50);
  });

  const initialise = () => updateScentDescription(selectedScent());
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
